import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Card,
  CardBody,
  Row,
  CardImg,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { NotificationManager } from "../../../../../components/common/react-notifications";
import {
  dAPI_Delete_Ingetration,
  putAPI_Update_OnOff,
  API_CopyChatbot_Integration
} from '../../../../../constants/APIs';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { BrowserRouter as Router, NavLink } from 'react-router-dom';
import bot_icon from './../../../../../assets/bot_icon1.png';
export default function WebIntegrationThumb({
  integration,
  allProperties,
  LoadIntegrations,
  propertyId,
}) {
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [duplicateVisible, setDuplicateVisible] = useState(false);
  const [formatedProperties, setFormatedProperties] = useState('');
  const [moreProperties, setMoreProperties] = useState('');
  const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(
    !integration.disabled
  );
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const result = integration.properties.map((id) => {
      return allProperties.find((elem) => elem.id === id);
    });
    // console.log(result)
    if (result.length > 2) {
      const filterResults = result.slice(0, 2);
      // console.log(filterResults)
      if (filterResults !== null && filterResults.length > 0) {
        setFormatedProperties(filterResults.map((elem) => elem?.name).join(', '));
        setMoreProperties(
          'and ' + (result.length - filterResults.length) + ' more'
        );
      }
    } else {
      const filterResults = result.filter((elem) => elem !== undefined);
      //console.log(filterResults)
      if (filterResults !== null && filterResults.length > 0) {
        setFormatedProperties(filterResults.map((elem) => elem?.name).join(', '));
      }
    }
  }, [integration, allProperties]);

  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };

  const toggle_duplicate = () => {
    setDuplicateVisible(!duplicateVisible);
  };
  const handleDelete = () => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${integration.id
        }/?group_id=${getGroupID()}`,
    }).then((res) => {
      toggle();
      LoadIntegrations();
    });
  };
  const handleOnOff = (onoff) => {
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_OnOff}/${integration.id}/?group_id=${getGroupID()}`,
      data: { disabled: onoff },
    }).then((res) => {
      console.log('on/off');
    });
  };

  const handleSwitchChange = (value) => {
    //console.log(value)
    setCheckedPrimarySmall(value);
    handleOnOff(!value);
  };
  const handleDuplicate = async () => {
    try {
      setLoading(true);

      const payload = {
        integrationId: integration.id,
        groupId: getGroupID(),
      };
      await AxiosAPI({
        method: 'post',
        url: API_CopyChatbot_Integration,
        data: payload,
      });

      NotificationManager.success(
        'Integration copied successfully',
        'Success',
        5000
      );

      toggle_duplicate();
      LoadIntegrations();

    } catch (error) {
      console.error(error);
      NotificationManager.error(
        'Failed to copy integration',
        'Error',
        5000
      );
    } finally {
      setLoading(false);
    }
  };

  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This action will permanently remove the integration. Are you sure you want to delete the integration?
                </ModalHeader>
                <ModalBody className="d-flex justify-content-space-between">
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Go Back
                  </Button>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Confirm
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  const generateDuplicateButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={duplicateVisible} toggle={toggle_duplicate}>
                <ModalHeader toggle={toggle_duplicate}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This action will make a copy of the current channel. Are you sure you want to proceed?
                </ModalHeader>
                <ModalBody className="d-flex justify-content-space-between">
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle_duplicate}
                  >
                    Go Back
                  </Button>
                  <Button
                    color="danger"
                    onClick={() => handleDuplicate()}
                    size="xs"
                  >
                    Confirm
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  return (
    <Fragment>
      {
        loading ? (
          <div className="text-center" style={{ position: 'absolute', zIndex: '9999' }} >
            <div className="loading" />
          </div >
        ) :
          <>
            {integration ? (
              <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                <Card className="d-flex flex-row" style={{ height: '215px' }}>
                  <div>
                    <h3 className="integrationChannel">
                      <img
                        src={bot_icon}
                        alt="Logo"
                        style={{ maxWidth: '30px' }}
                      />
                    </h3>

                    {/* <a href="#/" className="integrationremove"
                onClick={toggle}
              >
                {" "}
                <h3 className="iconsminds-remove" />{" "}
              </a> */}
                    <Switch
                      className="agentswitch custom-switch-primary custom-switch-small integrationremove"
                      checked={checkedPrimarySmall}
                      onChange={(primary) => handleSwitchChange(primary)}
                    />
                  </div>
                  <CardBody>
                    <Row>
                      <Colxx xxs="12" className="mb-3">
                        <NavLink
                          to={{
                            pathname:
                              '/app/pages/integrationdetail/' + integration.id,
                          }}
                          key={integration.id}
                        >
                          <div className="text-center">
                            <CardImg
                              top
                              src={
                                integration.botSettings
                                  ? integration.botSettings.urls.icon
                                  : ''
                              }
                              alt="Card image cap"
                              className="img-thumbnail border-0 rounded-circle list-thumbnail"
                            />
                            <div className="mb-1">
                              {integration.botSettings
                                ? integration.botSettings.name
                                : ''}
                            </div>
                            <div className="mb-1">
                              {integration ? integration.name : null}
                            </div>
                            <div className="mb-2">
                              <b>{formatedProperties} </b>

                              <b>{moreProperties}</b>
                            </div>
                            {/* <div className="mb-1">
                        <h3 className="simple-icon-eye m-2" />
                      </div> */}
                          </div>
                        </NavLink>
                      </Colxx>
                    </Row>
                  </CardBody>
                  {integration.properties.length > 1 ? '' :
                    <div className='integrationduplicate'>
                      <button onClick={toggle_duplicate} title='Copy'>
                        <i className='iconsminds-duplicate-layer' style={{ color: 'var(--theme-color-1)' }} />
                      </button>
                    </div>
                  }
                  <div className='integrationdelete'>
                    <FontAwesomeIcon
                      icon={faTrashAlt}
                      style={{ color: 'var(--theme-color-1)' }}
                      cursor="pointer"
                      onClick={toggle}
                    />
                  </div>
                </Card>
              </Colxx>
            ) : null}
            {generateDeleteButton()}
            {generateDuplicateButton()}
          </>
      }
    </Fragment>
  );
}
